import { TypeImagesSectionWithoutUnresolvableLinksResponse } from 'bb-contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import ImagesSection from './ImagesSection'

const ContentfulImagesSection = withContentful<TypeImagesSectionWithoutUnresolvableLinksResponse>(ImagesSection)

export default ContentfulImagesSection
